import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["name", "variant", "centered", "children", "className"];
import * as React from 'react';
import clsx from 'clsx';
import { useTranslator } from '@gandi/translate';
import Products from './Products';
import Dots from './Dots';
var styles = {
  "root": "Spinner-root_10wsp",
  "centered": "Spinner-centered_THCYZ"
};
function Spinner(_ref) {
  var _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'products' : _ref$name,
    variant = _ref.variant,
    centered = _ref.centered,
    children = _ref.children,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslator = useTranslator(),
    __ = _useTranslator.__;
  var rootClasses = clsx(styles.root, centered && styles.centered, className);
  var title = typeof children === 'string' ? children : __('Loading...');
  if (name === 'dots') {
    // $FlowFixMe[cannot-spread-inexact]
    return /*#__PURE__*/React.createElement(Dots, _extends({
      title: title,
      className: rootClasses
    }, extraProps));
  }
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Products, _extends({
      variant: variant,
      title: title,
      className: rootClasses
    }, extraProps))
  );
}
export default Spinner;